{
  "loading": "Ładowanie...",
  "placeholder": "Zaznacz…"
}
